import OktaAuthenticate, { navigationGuard, getCurrentUser } from './okta-authenticate';

export default OktaAuthenticate;
export { navigationGuard, getCurrentUser };